import React, { Component } from 'react';
import moment from 'moment';
import networkList from '../../../constants/networkList';
const {homepage} = networkList;
class PrintConsent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            'printData': {}
        }
    }

    componentDidMount() {
        window.scrollTo({
            top: 50,
            left: 0,
            behavior: 'smooth'
        });
    }
    print = () => {
        document.getElementById("myH1").style.margin = "-130px 0px 0px 0px";
        window.print();
        document.getElementById("myH1").style.margin = "0px";
    }
    cancelPrint(){
        this.props.cancel()
    }
    render() {
        let { printData} = this.state;
        let user_data
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        return (
            <div className="fc-patient-copy">
                <div className="p-4 bg-white" id="myH1">
                    <div className="clearfix pt-5">
                        <img src={`${homepage}/assets/images/units-logo/${user_data["unitid"]&&user_data["unitid"]}.png`} alt="Kims" className="float-left"></img>
                        <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/05</p>
                    </div>
                    <div>
                        <h1 className="text-p-bold text-center text-uppercase py-4">BILLING GUIDELINES FOR INSURANCE</h1>
                    </div>
                    {/* information */}
                    <div className="p-2 pb-3">
                        <p className="one text-justify">The following items will not be covered by the insurance & corresponding amount shall be collected at the time of discharge</p>
                        <ul className="pl-3">
                            <li>Disinfectant charges, Instrument charges and Laser equipment</li>
                            <li><strong>Disposables:</strong> Gloves , Masks (Nebulization/Oxygen/Cpap), Underpads, EZ Bath, Caps, Tegaderm Ortho Roll, Dressing Pads, HME Filters, Hand Rubs, Dettol, Mouthwash, Splints, Drapes, Thermometer</li>
                            <li><strong>Equipment:</strong> Alpha Bed, Warmers, Bipap</li>
                            <li><strong>Hospital Services:</strong> Patient gowns & other linen, Laundry, FnB, Dental care, Medical record charges, MLC charges, Diet consultations, Ambulance charges, Additional CD/DVD charges, Attendant stay, Registration fees, Cosmetic accessories</li>
                            <li><strong>Investigations & Procedures:</strong> Blood grouping, Viral screening-HIV/HCV/HBsAG, TSH/T3/T4 for non-diabetic patients, any investigations that prescribed during cross consultations that are normal in result, GRBS, Lipid profile, Cosmetic procedures, IVF procedures, Dental procedures, treatment for viral positive cases, any unrelated investigations.</li>
                            <li>Vaccination & sterilization charges</li>
                            <li>Service charges, surcharges and insurance processing fees.</li>
                            <li>Any charges related to new born baby during maternity admissions (unless authorized by Insurance Provider)</li>
                        </ul>
                    </div>
                    <div className="p-2 pb-3">
                        <strong>Note:</strong>
                        <ul className="pl-3">
                            <li>Approvals are not sanctioned for investigations done for the purpose of evaluation, unless followed by an active line of clinical management.</li>
                            <li>Any difference in room rent amount, co-payment and proportionate deductions are not payable by the insurance provider & shall be borne by the patient</li>
                            <li>Congenital and pre-existing diseases (before inception of policy) are not covered under insurance. Kindly refer to your policy document.</li>
                            <li>Packages: Any treatment done that is beyond the package duration or not included in the package will be billed and submitted separately. If it is not approved, the charges shall be payable by the patient.</li>
                            {/* <li>Any misrepresentation of facts may result in nullification of approval letter & it will stand void. Patient shall pay the full amount.</li> */}
                            <li>Non-disclosure of medical history or any misrepresentation of facts may result in nullification of approval letter & it will stand void. In such cases, the total bill shall be payable by the patient.</li>
                            {/* <li>If approval is not granted or it is rejected at any point before the discharge of the patient, the total bill shall be paid by patient.</li> */}
                            <li>If approval is not granted or claim is rejected at any point before discharge, the total bill shall be payable by the patient.</li>
                            <li>Room Upgrade & other related charges are payable by the patient as per the terms of the insurance policy. </li>
                            <li>An advance amount is collected at the time of admission if the pre-authorization approval is not received.
                            Dues will be followed up as per hospital policy until the time approval is received. Any excess amount paid will be refunded at the time of discharge after appropriate deductions.</li>
                            <li>Some procedures have an ‘ailment capping’ where only a fixed amount is covered by the insurance provider. Please check with your insurance provider for details.</li>
                            <li>Generally, room eligibility is calculated as a percentage of Sum Assured (1% for wards & 2% for ICUs). Please check with your insurance provider for your room eligibility. </li>
                            <li>KYC form along with policy holder’s PAN & Aadhar card is required in case initial estimate is above Rs 1,00,000.</li>
                        </ul>

                    </div>
                    <p className="one text-justify">I hereby give my consent to pay the full hospital bill before discharge, in case approval is not sanctioned / rejected by TPA/Insurance.</p>
                    <p className="one text-justify">I shall pay full amount towards co-payment, Non Medical expenses, Room upgrade charges and any other difference amount as notified to me.</p>
                    <div className="pt-5 pb-4">
                        <div class="d-flex justify-content-between">
                            <span>
                                Signature: _________________________
                            </span>
                            <span>
                            Date: ___________________________
                            </span>
                        </div>
                        <div class="d-flex justify-content-between pt-5">
                            <span>
                            Patient/Attendant Name: _______________
                                
                            </span>
                            <span>
                            Relationship to patient: _______________
                                
                            </span>
                        </div>
                        <div class="d-flex justify-content-between pt-5">
                            <span>
                            Phone Number: ______________________
                            </span>
                            {/* <span>
                                Financial Counsellor: ______________________
                            </span> */}
                        </div>
                        <div className="row justify-content-center p-4 pt-4 position-fixed" style={{'bottom': '8px',left: '40%'}}>
                            <button className="btn btn-success d-print-none text-capitalize" onClick={this.print}>Print</button>
                            <button className="btn btn-success  d-print-none btn-next text-capitalize ml-3" onClick={this.cancelPrint.bind(this)}>cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default PrintConsent;